import { EnvUtils } from '@ecm/dispatcher';

import { AccessCode } from '../enums/access-code.enum';

export class AccessCodeUtils {
    /**
     * Get acces code
     * Assistance (SOLI) : based on env.ORIGIN via SSI
     * webview app : based on `BRAND` value (from env.json)
     * other apps : based on `BASICAT` value (from process.env)
     * @param {any} env
     * @return {AccessCode|string}
     */
    public static getAccesCodeFromEnvironment(env: any): AccessCode | string {
        let accesCode: AccessCode;
        if (env.ORIGIN) {
            accesCode = env.ORIGIN;
        } else if (EnvUtils.isWebview() && env.BRAND) {
            const envBrand: string = env.BRAND.toLowerCase();
            accesCode = envBrand === 'sosh' ? AccessCode.MYH : AccessCode.OEM;
        } else {
            const envBasicatCode: string = EnvUtils.getBasicatCode();
            accesCode = AccessCode[envBasicatCode] ? AccessCode[envBasicatCode] : AccessCode.ECQ;
        }
        return accesCode;
    }
}
